export enum PersonaInquiryType {
  DriverLicense = 'driver_license',
  BusinessEntity = 'business_entity',
}

export const PERSONA_ERROR_CODES = [
  'application_error',
  'invalid_config',
  'unauthenticated',
  'inactive_template',
  'unknown',
]
